import Button from "../Button/Button";
import Heading from "../Heading";
import Icon from "../Icon";
import Markdown from "../Markdown";
import React, { useState } from 'react';
import { CookieContent, StyledCookieDetails, StyledHeader } from "./CookiesStyle";
var CookiesDetailsMandatory = function (_a) {
    var title = _a.title, description = _a.description, cookies = _a.cookies, moreInfoLabel = _a.moreInfoLabel, lessInfoLabel = _a.lessInfoLabel;
    var _b = useState(false), showMoreInfo = _b[0], setShowMoreInfo = _b[1];
    return (React.createElement(StyledCookieDetails, null,
        React.createElement(StyledHeader, null,
            React.createElement(Heading.Heading6, { fontWeight: "extraBold" }, title),
            React.createElement(Icon.Check, { height: 32, width: 32 })),
        React.createElement(Markdown, { children: description }),
        showMoreInfo && (React.createElement(CookieContent, null,
            React.createElement("table", { className: "responsive-table" },
                React.createElement("tbody", null, cookies.map(function (cookie) { return (React.createElement("tr", { key: cookie.Name }, Object.entries(cookie).map(function (_a) {
                    var key = _a[0], value = _a[1];
                    return (React.createElement("td", { key: key, "data-label": key },
                        React.createElement("span", null, value || '-')));
                }))); }))))),
        React.createElement(Button, { ghost: true, onClick: function () { return setShowMoreInfo(function (prevState) { return !prevState; }); } }, !showMoreInfo ? moreInfoLabel : lessInfoLabel),
        React.createElement("hr", null)));
};
export default CookiesDetailsMandatory;
//# sourceMappingURL=CookiesDetailsMandatory.js.map